import { MapLayer } from 'features/mapping/mapping.constants';
import { usePrevious } from 'hooks/usePrevious';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useMapLayersState } from 'state/useMapLayersState';

export const useRequireMapLayerForRouterEntity = (layer?: MapLayer): void => {
  const { mapLayers, setMapLayerVisibility } = useMapLayersState();
  const history = useHistory();
  const hasInitialized = useRef(false);

  const isLayerActive = layer ? mapLayers.includes(layer) : false;
  const prevIsLayerActive = usePrevious(isLayerActive);

  // Enable layer on mount if needed, and mark as initialized
  useEffect(() => {
    if (!layer || hasInitialized.current) {
      return;
    }

    if (!isLayerActive) {
      setMapLayerVisibility(layer, true);
    }
    hasInitialized.current = true;
  }, [isLayerActive, layer, setMapLayerVisibility]);

  // Redirect to home if layer is manually disabled after initialization
  useEffect(() => {
    if (prevIsLayerActive && !isLayerActive) {
      const { search, hash, state } = history.location;
      history.push({ pathname: '/', search, hash, state });
    }
  }, [isLayerActive, prevIsLayerActive, history]);
};
